module.exports = __webpack_public_path__ + "static/img/Competitive.cd4f580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Competitive.png
// module id = +JuE
// module chunks = 0